module.exports = __webpack_public_path__ + "static/media/bf8.7b26302c.png";